// Frontend constants and configuration
const constants = {
  // Admin configuration
  ADMIN_EMAIL: process.env.REACT_APP_ADMIN_EMAIL || 'maxsonsmith@gmail.com',
  MAIN_ADMIN_EMAIL: process.env.REACT_APP_MAIN_ADMIN_EMAIL || null,
  
  // Image upload limits by tier
  IMAGE_LIMITS: {
    FREE: 5,
    STARTER: 20,
    PROFESSIONAL: 50,
    BUSINESS: 100,
    ADMIN: -1 // Unlimited
  },
  
  // Grace period durations (in days)
  GRACE_PERIODS: {
    ACCOUNT_LOCK_DAYS: 2,
    ACCOUNT_CLOSE_DAYS: 32
  },
  
  // File size limits
  MAX_FILE_SIZE_MB: 20,
  MAX_FILE_SIZE_BYTES: 20 * 1024 * 1024, // 20MB in bytes
  
  // API configuration
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  
  // Email addresses
  SUPPORT_EMAIL: 'support@loracaption.com',
  BUGS_EMAIL: 'bugs@loracaption.com',
  
  // UI Constants
  TOAST_DURATION: 3000,
  DEBOUNCE_DELAY: 500,
  
  // Quality level options
  QUALITY_LEVELS: {
    STANDARD: 'standard',
    DETAILED: 'detailed',
    EXHAUSTIVE: 'exhaustive'
  },
  
  // Subscription tiers
  SUBSCRIPTION_TIERS: {
    FREE: 'free',
    STARTER: 'starter',
    PROFESSIONAL: 'professional',
    BUSINESS: 'business',
    ADMIN: 'admin'
  }
};

// Export individual constants for easier importing
export const ADMIN_EMAIL = constants.ADMIN_EMAIL;
export const SUPPORT_EMAIL = constants.SUPPORT_EMAIL;
export const BUGS_EMAIL = constants.BUGS_EMAIL;
export const IMAGE_LIMITS = constants.IMAGE_LIMITS;
export const GRACE_PERIODS = constants.GRACE_PERIODS;
export const MAX_FILE_SIZE_MB = constants.MAX_FILE_SIZE_MB;
export const MAX_FILE_SIZE_BYTES = constants.MAX_FILE_SIZE_BYTES;
export const API_BASE_URL = constants.API_BASE_URL;
export const QUALITY_LEVELS = constants.QUALITY_LEVELS;
export const SUBSCRIPTION_TIERS = constants.SUBSCRIPTION_TIERS;

export default constants;